import Amount from './Amount';

export function printExchangeRate(value: Amount, language?: string): string {
	return value.toDotNotation(1000, false, language === 'bs' ? ',' : '.');
}
